import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignQuantityReducer = (state: DesignState, action: PayloadAction<number|undefined>) => {
  state.quantity = action.payload;
};

export default setDesignQuantityReducer;
